export default __webpack_public_path__ + "static/media/thumbnail.485aa559.webp";